export const globalStyles = {
  gridPadding: {
    desktop: '5.73vw',
    mobile: '5vw',
  },
}
